import axios from 'axios'
import HTTP from './http'

export default {
    getList: () => axios.get(HTTP.PRESET),
    updatePolicy: payload => axios.put(HTTP.PRESET, { payload }),
    setNewAges: payload => axios.patch(HTTP.PRESET, { payload })
}
